import { Redirect, useLocation } from "react-router-dom";

const RedirectSubjectComponentNew = () => {
  const location = useLocation();
  return (
    <Redirect
      to={{
        pathname: "/dashboard/student-learning",
        state: location.state,
      }}
    />
  );
};

export default RedirectSubjectComponentNew;
